export { default } from "./useGetTeam";
